import { z } from "zod"
import { stringRequired } from "@/models/common"
import { validTimeRegex } from "@/modules/admin/news/constants"
import { combineDateAndTime } from "@/modules/admin/news/helpers/news-helper"
import { CriticalityLevel, DisplayFor } from "@/types/__generated__/union-types"

const validateEndDateTimeAfterStart = (endDate?: Date, endTime?: string, startDate?: Date, startTime?: string) => {
  if (startDate && startTime && endDate && endTime && validTimeRegex.test(startTime) && validTimeRegex.test(endTime)) {
    const startDateTime = combineDateAndTime(startDate, startTime)
    const endDateTime = combineDateAndTime(endDate, endTime)
    const startUnixTimestamp = Math.floor(new Date(startDateTime).getTime() / 1000)
    const endUnixTimestamp = Math.floor(new Date(endDateTime).getTime() / 1000)
    return endUnixTimestamp > startUnixTimestamp
  }
  return true
}

export const newsFormSchema = z
  .object({
    id: z.string().optional(),
    displayFor: z.array(z.custom<DisplayFor>()).min(1, {
      message: "common.fieldErrorList.requiredField",
    }),
    criticalityLevel: z.custom<CriticalityLevel>(),
    germanContent: stringRequired,
    englishContent: stringRequired,
    frenchContent: z.string(),
    italianContent: z.string(),
    startDate: z.date({ error: "common.fieldErrorList.requiredField" }),
    startTime: stringRequired.regex(validTimeRegex, { message: "common.fieldErrorList.invalidFormat" }),
    endDate: z.date().optional(),
    endTime: z
      .string()
      .refine((endTime) => !endTime || validTimeRegex.test(endTime), {
        message: "common.fieldErrorList.invalidFormat",
      })
      .optional(),
  })
  .refine((data) => validateEndDateTimeAfterStart(data.endDate, data.endTime, data.startDate, data.startTime), {
    message: "common.fieldErrorList.endDateTimeAfterStart",
    path: ["endDate"],
  })
  .refine((data) => validateEndDateTimeAfterStart(data.endDate, data.endTime, data.startDate, data.startTime), {
    message: "common.fieldErrorList.endDateTimeAfterStart",
    path: ["endTime"],
  })
  .refine(
    (data) => {
      if (data.endDate && !data.endTime) {
        return false
      }
      return true
    },
    {
      message: "common.fieldErrorList.endTimeRequired",
      path: ["endTime"],
    },
  )
